import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from 'react-intl';
import moment from 'moment';

//Components
import { Button, Input, Form, Select } from "@gpstrackit/react-controls";
import { Typography } from '@mui/material';
//Chars
import ChartPie from 'Modules/dashboard/views/.components/chart/.components/pie';
import ChartBar from 'Modules/dashboard/views/.components/chart/.components/bar';
import ChartLine from 'Modules/dashboard/views/.components/chart/.components/line';

//Styles
import './index.scss';

//Actions
import { sizeDashboardPanelCreateEditModal, chartDashboardPanelSearchDevelopersRequest } from 'Redux/actions'

const backgroundColor = [
    '#66BB6A',
    '#03A9F4',
    '#1D2734',
    '#018F82',
    '#13B2A3',
    '#37AFCC',
    '#00C6FC',
    '#00ACFB',
    '#008CDD',
    '#0059A0',
    '#2F4F6C',
    '#6685A7',
    '#825C8D',
    '#812F6F',
    '#006014',
    '#007F25',
    '#40BE60',
    '#69C97D',
    '#A9EAB3',
    '#ECB651',
    '#EA6947',
    '#D13C3C',
    '#AC2A47',
    '#C23E68',
    '#E97694',
]

const CreateEditChart = (props) => {
    const { onSubmit, handleClose } = props;
    const { messages, locale } = useIntl();

    const dispatch = useDispatch();
    const editCreateDashboardGadgets = useRef();

    //Local States
    const [formData, setFormData] = useState({});
    const [dataChart, setDataChart] = useState({});
    const [developersList, setDevelopersList] = useState([]);

    const { developers, loadingDevelopers } = useSelector(state => state.gadgetChartRedux)

    const optionsFrecuency = [
        { id: 300, name: messages['dashboard_gadget_five_minutes'] },
        { id: 900, name: messages['dashboard_gadget_fifteen_minutes'] },
        { id: 1800, name: messages['dashboard_gadget_thirty_minutes'] },
        { id: 3600, name: messages['dashboard_gadget_one_hour'] },
        { id: 7200, name: messages['dashboard_gadget_two_hour'] }
    ];

    const optionsReportType = [
        { id: `DeveloperMetrics`, name: messages['dashboard_gadget_developers_metrics'] },
    ];

    const optionsTimeMetric = [
        { id: `lastmonth`, name: messages['dashboard_gadget_last_month'] },
        { id: `quarter`, name: messages['dashboard_gadget_this_quarter'] },
        { id: `lastquarter`, name: messages['dashboard_gadget_last_quarter'] },
        { id: `year`, name: messages['dashboard_gadget_this_year'] },
        { id: `lastyear`, name: messages['dashboard_gadget_last_year'] },

    ]

    const optionsChartType = [
        { id: `column`, name: messages['dashboard_gadget_column'] },
        { id: `line`, name: messages['dashboard_gadget_line'] },
    ]

    const {
        loadingCreateEdit,
        gadGet
    } = useSelector((state) => state.dashboardPanelMainRedux);

    const validateData = () => {
        onSubmit({
            ...formData,
            refreshSeconds: formData.refreshSeconds.id
        })
    }

    useEffect(() => {
        dispatch(sizeDashboardPanelCreateEditModal('medium'));
        dispatch(chartDashboardPanelSearchDevelopersRequest())
    }, [])

    const dataChartChange = (timeMetric) => {
        let labels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        let data = [300, 50, 100, 200, 500, 600, 800];
        let data2 = [150, 40, 50, 100, 200, 300, 400];
        let start = moment();
        let end = moment().locale(locale);
        let monthPrevious = moment(end).subtract(1, "month");
        const quarter = moment().quarter();
        switch (timeMetric) {
            case 'lastmonth':
                const month = moment().subtract(1, 'month').format('MMM');
            case 'month':
                start = moment().subtract(30, 'days');
                labels = [month];
                data = [100];
                data2 = [56];
                break;
            case 'lastquarter':
                start = moment().quarter(quarter - 1).startOf('quarter').toDate()
				end = moment().quarter(quarter - 1).endOf('quarter').toDate()
                labels = [];
                data = [86, 50, 100];
                data2 = [75, 100, 50];
                monthPrevious = moment(end).subtract(1, "month");
				labels = [`${moment(start).format("MMM")}`, `${moment(monthPrevious).format("MMM")}`, `${moment(end).format("MMM")}`];
                break;
            case 'quarter':
                start = moment().startOf('quarter').toDate()
				end = moment.max(moment()).endOf('day').toDate()
                labels = [];
                data = [86, 50, 100];
                data2 = [75, 100, 50];
                monthPrevious = moment(end).subtract(1, "month")
				labels = [`${moment(start).format("MMM")}`, `${moment(monthPrevious).format("MMM")}`, `${moment(end).format("MMM")}`];
                break;
            case 'lastyear':
            case 'year':
                data = [86, 50, 100, 56, 67, 45, 34, 67, 98, 48, 56];
                data2 = [75, 100, 50, 97, 48, 38, 100, 30, 60, 48];
                labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
                break;
        }

        setDataChart({
            labels: labels,
            subTitle: ``,
            unit: "Total",
            data: [`${messages['dashboard_gadget_example']} 1`, `${messages['dashboard_gadget_example']} 2`, `${messages['dashboard_gadget_example']} 3`],
            title: messages['dashboard_gadget_developers_metrics'],
            datasets: [{
                id: 1,
                label: `${messages['dashboard_gadget_developer']} 1`,
                data,
                backgroundColor
            },
            {
                id: 2,
                label: `${messages['dashboard_gadget_developer']} 2`,
                data: data2,
                backgroundColor
            }]

        })
    }

    useEffect(() => {
        if (gadGet?.hasOwnProperty('name')) {
            let settings = JSON.parse(gadGet.settings);
            setFormData({
                ...formData,
                name: gadGet.name,
                reportType: optionsReportType.filter(type => type.id === settings.reportType.id)[0],
                chartType: optionsChartType.filter(chart => chart.id === settings.chartType.id)[0],
                timeMetric: optionsTimeMetric.filter(timeMetric => timeMetric?.id === settings?.timeMetric?.id)[0],
                refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === gadGet.refreshSeconds)[0],
                entities: settings.entities
            })
            dataChartChange(formData?.timeMetric?.id);

        } else {
            setFormData({ ...formData, chartType: optionsChartType[1] });
            dataChartChange(optionsTimeMetric[0])
        }
    }, [open, gadGet])

    useEffect(() => {
        if (developers && developers.length) {
            let temp = developers
            temp = temp?.slice()?.sort((a, b) => {
                const nameA = a.name.toUpperCase();
                const nameB = b.name.toUpperCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            });
            let devList = [/* { id: 'all', name: messages['dashboard_gadget_all_developers'] } */]
            temp.map((item) => {
                devList.push({ id: item.name, name: item.name })
            })
            setDevelopersList(devList)
        }
    }, [developers])

    return (
        <div className="create-edit-container">
            <div className="create-edit-preview" >
                <div className="create-edit-preview-chart" >
                    <Typography className="create-edit-preview-label" variant="subtitle1">
                        {messages['dashboard_gadget_preview']}
                    </Typography>
                    {formData?.chartType?.id === 'pie' && <ChartPie data={dataChart} />}
                    {formData?.chartType?.id === 'column' && <ChartBar data={dataChart} />}
                    {formData?.chartType?.id === 'line' && <ChartLine data={dataChart} />}
                </div>
            </div>
            <div className="create-edit-separator" >
                <Form
                    ref={editCreateDashboardGadgets}
                    onSubmit={() => {
                        return true
                    }}
                    onValidSubmit={validateData}
                    style={{ height: '100%' }}>
                    <div>
                        <div>
                            <Input
                                id="name"
                                value={formData.name || ""}
                                onChange={(value) => setFormData({ ...formData, name: value })}
                                minLength={1}
                                maxLength={25}
                                label={messages['dashboard_gadget_title']}
                                placeholder={messages['dashboard_gadget_title']}
                                type="text"
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div className="create-edit-form-item">
                            <Select
                                id="refreshSeconds"
                                label={messages['dashboard_gadget_frequency_refresh']}
                                placeholder={messages['dashboard_gadget_frequency_refresh']}
                                options={optionsFrecuency}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData.refreshSeconds}
                                onChange={(value) => setFormData({ ...formData, refreshSeconds: value })}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div className="create-edit-form-item">
                            <Select
                                id="reportType"
                                label={messages['dashboard_gadget_report_type']}
                                placeholder={messages['dashboard_gadget_report_type']}
                                options={optionsReportType?.sort((a, b) => (a.name > b.name) ? 1 : -1)}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData.reportType}
                                onChange={(value) => {
                                    setFormData({ ...formData, reportType: value, entities: [] })
                                }}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        {formData?.reportType?.id === "DeveloperMetrics" && (
                            <div className="create-edit-form-item">
                                <Select
                                    id="developerslist"
                                    label={messages['dashboard_gadget_developers']}
                                    placeholder={messages['dashboard_gadget_developers']}
                                    loading={loadingDevelopers}
                                    options={developersList}
                                    textField="name"
                                    valueField="id"
                                    isSearchable={false}
                                    value={formData.entities}
                                    onChange={(value) => {
                                        setFormData({ ...formData, entities: value });
                                    }}
                                    isClearable
                                    required
                                    multiple
                                    selectedOptionsBelow
                                    requiredMessage={messages['required_field']}
                                />
                            </div>
                        )}

                        <div className="create-edit-form-item">
                            <Select
                                id="chartType"
                                label={messages['dashboard_gadget_chart_type']}
                                placeholder={messages['dashboard_gadget_chart_type']}
                                options={optionsChartType}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData?.chartType}
                                onChange={(value) => {
                                    let View = (value === 'pie') ? {} : formData.View;
                                    setFormData({ ...formData, chartType: value, View });
                                }}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div className="create-edit-form-item" style={{ marginBottom: 190 }}>
                            <Select
                                id="timeMetric"
                                label={messages['dashboard_gadget_time_metric']}
                                placeholder={messages['dashboard_gadget_time_metric']}
                                options={optionsTimeMetric}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData.timeMetric}
                                onChange={(value) => {
                                    setFormData({ ...formData, timeMetric: value });
                                    dataChartChange(value.id);
                                }}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                    </div>
                </Form>
                <div className="create-edit-buttons" style={{ width: '100%', backgroundColor: '#fff' }}>
                    <Button
                        disabled={loadingCreateEdit}
                        className="btn-cancel"
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            dispatch(sizeDashboardPanelCreateEditModal('small'));
                            handleClose();
                        }}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        disabled={loadingCreateEdit}
                        onClick={(e) => editCreateDashboardGadgets.current.submit()}
                        className="btn-dark-blue"
                    >
                        {messages['save']}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default CreateEditChart